import { createServerFn } from '@tanstack/react-start';
import { z } from 'zod';
import { PortalOrdersBoard } from '@api/BoardSDK';
import { withBoardAuth } from '@generated/server/boardAuth.server';

const GEORGE_ID = '106410322';

/** $15 each, or $25 per pair — free shipping. */
export function mugPrice(qty: number) {
  return Math.floor(qty / 2) * 25 + (qty % 2) * 15;
}

export const orderMugs = createServerFn({ method: 'POST' })
  .validator((d: unknown) => z.object({
    name: z.string().trim().min(1).max(120),
    email: z.string().trim().min(3).max(200),
    phone: z.string().trim().max(40),
    address: z.string().trim().min(5).max(500),
    qty: z.number().int().min(1).max(20),
    paymentMethod: z.string().trim().max(40),
    notes: z.string().trim().max(500),
  }).parse(d))
  .handler(async ({ data }) => withBoardAuth(async () => {
    const amount = mugPrice(data.qty);
    const board = new PortalOrdersBoard();
    const item = await board.item().create({
      name: `Mug order — ${data.name}`,
      status: 'New Order',
      orderDate: new Date(),
      contactPerson: data.name,
      email: { email: data.email, label: data.email },
      ...(data.phone ? { phone: { phone: data.phone, country: 'US' } } : {}),
      publication: 'Star-Revue Mug',
      adSize: `${data.qty} mug${data.qty > 1 ? 's' : ''}`,
      duration: 'Merchandise',
      totalContractValue: amount,
      paymentMethod: data.paymentMethod,
      specialInstructions: `SHIP TO:\n${data.name}\n${data.address}${data.notes ? `\n\nNotes: ${data.notes}` : ''}`,
    }).execute();
    try { await board.item(item.id).notify(GEORGE_ID).create(`New mug order: ${data.qty} for ${data.name} — $${amount} by ${data.paymentMethod}`).execute(); }
    catch (e) { console.error('[mugs] notification failed', e); }
    return { id: item.id, amount };
  }));
